import { type ReactElement } from 'react';
import { TdsTag } from '@scania/tegel-react';
import { NotAvailable } from '../../../NotAvailable';

interface SpecificationCellProperties {
  readonly configuration: string;
  readonly batteryCapacity?: number;
  readonly socWindow?: number;
}

const SpecificationCell = ({
  configuration,
  batteryCapacity,
  socWindow,
}: SpecificationCellProperties): ReactElement => {
  if (!configuration && batteryCapacity === undefined && socWindow === undefined) {
    return (
      <div className="tds-u-flex tds-u-gap1">
        <NotAvailable />
      </div>
    );
  }

  return (
    <div className="tds-u-flex tds-u-gap1">
      {typeof batteryCapacity === 'number' && <TdsTag size="sm" text={`${batteryCapacity} kWh`} variant="Neutral" />}
      {typeof socWindow === 'number' && <TdsTag size="sm" text={`${socWindow} %`} variant="Neutral" />}
      {configuration && <TdsTag size="sm" text={configuration} variant="Neutral" />}
    </div>
  );
};

export default SpecificationCell;
